import './contract_details.css'

import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';

import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import AppBar from '@mui/material/AppBar';
import swal from 'sweetalert';
import MenuItem from '@mui/material/MenuItem';
import { FormControl, InputLabel, Select } from '@mui/material';
import Loading_animation_view from '../../../loading_animation_view/loading_animation_view';
import { get_contract_details, get_directions_and_responsible, get_contract_values_lists } from '../../../../services/purchase_service'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: 16,
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

function Contract_detail({ id_contract, details }) {
    const [disabled, setDisabled] = useState(true);
    const [subject, setSubject] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [durationYears, setDurationYears] = useState("");
    const [renewable, setRenewable] = useState(false);
    const [financialTerms, setFinancialTerms] = useState("");
    const [paymentTerms, setPaymentTerms] = useState("");
    const [terminationConditions, setTerminationConditions] = useState("");
    const [latePenalties, setLatePenalties] = useState("");
    const [billingTerms, setBillingTerms] = useState("");
    const [applicableLaw, setApplicableLaw] = useState("");
    const [deliverables, setDeliverables] = useState([]);
    const [directors, setDirectors] = useState([]);
    const [directions, setDirections] = useState([]);
    const [director, setDirector] = useState('');
    const [direction, setDirection] = useState('');
    const [valuesLists, setValuesLists] = useState({
        financial_terms: [],
        billing_terms: [],
        payment_terms: [],
    });

    useEffect(() => {
        if (details) {
            setSubject(details.subject || "");
            setStartDate(details.start_date || "");
            setEndDate(details.end_date || "");
            setDurationYears(details.duration_years || "");
            setRenewable(details.renewable || false);
            setFinancialTerms(details.financial_terms || "");
            setPaymentTerms(details.payment_terms || "");
            setTerminationConditions(details.termination_conditions || "");
            setLatePenalties(details.late_penalties || "");
            setBillingTerms(details.billing_terms || "");
            setApplicableLaw(details.applicable_law || "");
            setDeliverables(details.deliverables || []);
            setDirector(details.director || '');
            setDirection(details.direction || '');

        }
        get_directions_and_responsible().then((res) => {
           //  console.log("Directions and directors: ", res.data);
            setDirectors(res.data.directors || []);
            setDirections(res.data.directions || []);
        })
            .catch((err) => {
                console.error("Error fetching directions and departments: ", err);
            });
        get_contract_values_lists().then((res) => {
           //  console.log("values: ", res.data);
            setValuesLists(res.data);

        }).catch((err) => {
            console.error("Error fetching directions and departments: ", err);
        });
    }, [details]);
    const selectedDirection = directions.find((d) => d.id === direction);
    const selectedDirector = directors.find((d) => d.id === director);





    return (
        <div className="contract_details_container">
            <div className="contract_form_details_container">
                <div className="contract_form_infos_container">
                    <div className='contract_form_infos_title'> 1 - Infos générale</div>
                    <Row className="mb-12">
                        <Form.Group className="col-6">
                            <label>Objet</label>
                            <Form.Control
                                required
                                autoComplete
                                type="text"
                                value={subject}
                                disabled={disabled}
                                onChange={(e) => setSubject(e.target.value)}

                            />
                        </Form.Group>
                        <Form.Group className="col-6">
                            <label>Direction</label>
                            <Form.Control
                                type="text"
                                value={selectedDirection ? selectedDirection.title : '—'}
                                disabled
                            />
                        </Form.Group>
                        <Form.Group className="col-6">
                            <label>Responsable</label>
                            <Form.Control
                                type="text"
                                value={selectedDirector ? selectedDirector.fullName : '—'}
                                disabled
                            />
                        </Form.Group>
                        <Form.Group className="col-6">
                            <label>Date de début</label>
                            <Form.Control
                                required
                                autoComplete
                                type="date"
                                value={startDate}
                                disabled={disabled}
                                onChange={(e) => setStartDate(e.target.value)}

                            />
                        </Form.Group>
                        <Form.Group className="col-6">
                            <label>Date de fin</label>
                            <Form.Control
                                required
                                autoComplete
                                type="date"
                                value={endDate}
                                disabled={disabled}
                                onChange={(e) => setEndDate(e.target.value)}

                            />
                        </Form.Group>
                        <Form.Group className="col-6"> </Form.Group>
                        <Form.Group className="col-6">
                            <label>Durée (années)</label>
                            <Form.Control
                                required
                                autoComplete
                                value={durationYears}
                                disabled={disabled}
                                onChange={(e) => setDurationYears(e.target.value)}

                            />
                        </Form.Group>
                        <Form.Group className="col-6">
                            <label>Renouvelable</label>
                            <Form.Check
                                // label="oui"
                                type="checkbox"
                                checked={renewable}
                                disabled={disabled}
                                onChange={(e) => setRenewable(e.target.checked)}
                            />
                            <span>Oui</span>
                        </Form.Group>

                    </Row>
                    <div className='contract_form_infos_title'>2 - Conditions du contract</div>
                    <Row className="mb-12">
                        <Form.Group>
                            <FormControl
                                variant="outlined"
                                className="input_form"
                                fullWidth
                                size="small"
                                disabled={disabled}

                            >
                                <label>Conditions de financières</label>

                                <Select
                                    value={financialTerms}
                                    onChange={(e) => setFinancialTerms(e.target.value)}

                                >
                                    {valuesLists.financial_terms.map((item) => (
                                        <MenuItem key={item.code} value={item.code}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Form.Group>

                        <Form.Group>
                            <FormControl
                                variant="outlined"
                                className="input_form"
                                fullWidth
                                size="small"
                                disabled={disabled}
                            >
                                <label>Conditions de paiement</label>
                                <Select
                                    value={paymentTerms}
                                    onChange={(e) => setPaymentTerms(e.target.value)}
                                >
                                    {valuesLists.payment_terms.map((item) => (
                                        <MenuItem key={item.code} value={item.code}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Form.Group>

                        <Form.Group>
                            <FormControl
                                variant="outlined"
                                className="input_form"
                                fullWidth
                                size="small"
                                disabled={disabled}
                            >
                                <label>Conditions de facturation</label>
                                <Select
                                    value={billingTerms}
                                    onChange={(e) => setBillingTerms(e.target.value)}
                                    label="Conditions de facturation"
                                >
                                    {valuesLists.billing_terms.map((item) => (
                                        <MenuItem key={item.code} value={item.code}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Form.Group>


                    </Row>
                    <div className='contract_form_infos_title'>3 - Autres informations</div>
                    <Row className="mb-12">
                        <Form.Group className="col-sm-12">
                            <label>Pénalités de retard</label>
                            <Form.Control
                                required
                                autoComplete
                                type="text"
                                minRows={3}
                                placeholder="Projet *"
                                value={latePenalties}
                                onChange={(e) => setLatePenalties(e.target.value)}
                                disabled={disabled}

                            />
                        </Form.Group>
                        <Form.Group >
                            <label>Conditions de résiliation</label>
                            <TextField
                                required
                                autoComplete
                                multiline
                                fullWidth
                                rows={3}
                                value={terminationConditions}
                                onChange={(e) => setTerminationConditions(e.target.value)}
                                disabled={disabled}
                            />
                        </Form.Group>

                        <Form.Group>
                            <FormControl variant="outlined" className="input_form" fullWidth size="small" disabled={disabled}>
                                <label>Droit applicable</label>
                                <Select

                                    value={applicableLaw}
                                    onChange={(e) => setApplicableLaw(e.target.value)}

                                >
                                    <MenuItem value="Marocain">Marocain</MenuItem>
                                    <MenuItem value="Français">Français</MenuItem>
                                </Select>
                            </FormControl>
                        </Form.Group>
                        <Form.Group >
                            <FormControl variant="outlined" className="input_form" fullWidth size="small" disabled={disabled}>
                                <label>Livrables</label>
                                <Select
                                    multiple
                                    value={deliverables}
                                    onChange={(e) => setDeliverables(e.target.value)}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    <MenuItem value="Rapport final">Rapport final</MenuItem>
                                    <MenuItem value="Code source">Code source</MenuItem>
                                    <MenuItem value="Documentation">Documentation</MenuItem>
                                </Select>
                            </FormControl>
                        </Form.Group>

                    </Row>

                </div>
            </div>
        </div >
    )
}


function Contract_details({ id_contract, setId_contract }) {
    const [details, setDetails] = useState(null);
    const [wait_submitting, setWait_submitting] = useState(false);
    const classes = useStyles();

    useEffect(() => {
        if (!id_contract) return;
        setDetails(null);
        setWait_submitting(true);

        async function load_data() {
            await get_contract_details(id_contract).then((response)=>{
               //  console.log(response);
                setDetails(response.data.data);
            }).catch((error)=>{
                 swal("Aucun contrat associé !", {
                    icon: "warning",
                }).then(async (willDelete) => {
                    if (willDelete) {
                        setId_contract(null);
                    }
                })
            });
            setWait_submitting(false);
        }



        load_data();

    }, [id_contract]);



    return (
        <Dialog disableEnforceFocus fullScreen open={id_contract ? true : false} onClose={() => setId_contract(null)} className="my_full_dialog contract_full_dialog">
            <AppBar className={classes.appBar}  >
                <Toolbar style={{ backgroundColor: '#343a40' }} >
                    <div className='page_title'>
                        <IconButton edge="start" color="inherit" onClick={() => setId_contract(null)} aria-label="close" >
                            <CloseIcon className="my_icon" />
                        </IconButton>
                        {/* <span> Details  du contract : {id_contract} </span> */}
                        <span> Details  du contract  </span>
                    </div>
                </Toolbar>
            </AppBar>

            {
                details !== null
                    ? <div className="contract_details_container">
                        <Contract_detail
                            id_contract={id_contract}
                            details={details} />


                    </div>
                    : <Loading_animation_view />
            }



            {/* <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={wait_submitting}
            >
                <CircularProgress color="inherit" />
            </Backdrop> */}

        </Dialog>
    )
}

export default Contract_details;